<template>
    <reports-base
        page-size-changeable
        exportable
        reportsName="promoRealizations"
        reportsTitle="Raport/ Realizacja promocji"
        componentName="PromoRealization"
        v-if="generateReports"
        @onExport="onExport"
    >
        <div class="c-thead">
            <div class="c-tw w-left">
                <div class="c-td is-1">ID promocji</div>
                <div class="c-td is-2">Promocja</div>
            </div>
            <div class="c-tw w-right">
                <div class="c-td is-3">Status</div>
                <div class="c-td is-4">Liczba użyć</div>
                <div class="c-td is-5">Kwota refundacji</div>
                <div class="c-td is-6">Lokalizacje</div>
            </div>
        </div>
    </reports-base>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    data() {
        return {
            generateReports: false
        }
    },
    components: {
        ReportsBase
    },
    created() {
        this.$store.dispatch('devicesFetch').then(() => {
            this.generateReports = true
        })
    },
    methods: {
        onExport() {
            this.$store.dispatch('getPromoRealizationReport')
        }
    }
}
</script>